import { render, staticRenderFns } from "./ChangeProductJudge.vue?vue&type=template&id=aaaa8ebe&scoped=true&"
import script from "./ChangeProductJudge.vue?vue&type=script&lang=ts&"
export * from "./ChangeProductJudge.vue?vue&type=script&lang=ts&"
import style0 from "./ChangeProductJudge.vue?vue&type=style&index=0&id=aaaa8ebe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaaa8ebe",
  null
  
)

export default component.exports